/* eslint-disable jsx-a11y/anchor-is-valid */
import { MenuComponent } from '_metronic/assets/ts/components'
import { useEffect } from 'react'
import { KTSVG } from '_metronic/helpers'

interface Prop {
  id: any
  onClickView?: (id: any) => void
  onClickEdit?: (id: any) => void
  onClickDelete?: (id: any) => void
  onAssignSales?: (id: any) => void
  onClickDuplicate?: (id: any) => void
  onClickPrint?: (id: any) => void
  onClickApprove?: (id: any) => void
  onClickReject?: (id: any) => void
  onDownloadApproverSignature?: (id: any) => void
  onUploadApproverSignature?: (id: any) => void
  onEditNoteOther?: (id: any) => void
  createProject?: (id: any) => void
  viewProject?: (id: any) => void
  hideView?: boolean
  hideEdit?: boolean
  hideDelete?: boolean
  hideAssignSales?: boolean
  hideDuplicate?: boolean
  hideCreateProject?: boolean
  hideViewProject?: boolean
  hidePrint?: boolean
  hideApprove?: boolean
  hideReject?: boolean
  hideDownloadApproverSignature?: boolean
  hideUploadApproverSignature?: boolean
  hideEditNoteOther?: boolean
}

const CustomActionCell: React.FC<Prop> = ({
  id,
  onClickView,
  onClickEdit,
  onClickDelete,
  onAssignSales,
  onClickDuplicate,
  onClickPrint,
  onClickApprove,
  onClickReject,
  onDownloadApproverSignature,
  onUploadApproverSignature,
  onEditNoteOther,
  createProject,
  viewProject,
  hideView,
  hideAssignSales,
  hideEdit,
  hideDelete,
  hideDuplicate,
  hideCreateProject,
  hideViewProject,
  hidePrint,
  hideApprove,
  hideReject,
  hideDownloadApproverSignature,
  hideUploadApproverSignature,
  hideEditNoteOther,
}) => {
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  return (
    <>
      <a
        className='btn btn-icon btn-custom btn-active-light rounded-circle'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'>
        <img src='/media/icons/dots-vertical.png' alt='Dot Vertical Icon' width={20} height={20} />
      </a>
      {/* begin::Menu */}

      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4'
        data-kt-menu='true'>
        {/* begin::Menu item */}
        {!hideView && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3'
              onClick={() => {
                onClickView && onClickView(id)
              }}>
              <div className='d-flex flex-row align-items-center'>
                <img className='me-2' src='/media/icons/eye-grey.svg' alt='Edit Icon' />{' '}
                <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                  ดู
                </div>
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideEdit && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickEdit) {
                  onClickEdit(id)
                }
              }}>
              <img className='me-2' src='/media/icons/edit-05-grey.svg' alt='Edit Icon' />{' '}
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                แก้ไข
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideDuplicate && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickDuplicate) {
                  onClickDuplicate(id)
                }
              }}>
              <img
                className='me-2'
                src='/media/icons/copy.svg'
                alt='Edit Icon'
                width={16}
                height={16}
              />{' '}
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                คัดลอก
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideDelete && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                onClickDelete && onClickDelete(id)
              }}>
              <img className='me-2' src='/media/icons/delete.svg' alt='Edit Icon' />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ลบ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideCreateProject && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (createProject) {
                  createProject(id)
                }
              }}>
              <img
                className='me-2 w-20px'
                src='/media/icons/duotune/files/fil005.svg'
                alt='Create Project Icon'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                สร้างโครงการ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideViewProject && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (viewProject) {
                  viewProject(id)
                }
              }}>
              <img
                className='me-2 w-20px'
                src='/media/icons/duotune/files/fil005.svg'
                alt='Create Project Icon'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ดูโครงการ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hidePrint && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickPrint) {
                  onClickPrint(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/files/fil017.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                พิมพ์เอกสาร
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideApprove && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickApprove) {
                  onClickApprove(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr020.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                อนุมัติแบบสำรวจ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideReject && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickReject) {
                  onClickReject(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr019.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ปฏิเสธแบบสำรวจ
              </div>
            </a>
          </div>
        )}

        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideUploadApproverSignature && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onUploadApproverSignature) {
                  onUploadApproverSignature(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/files/fil014.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                อัปโหลดลายเซ็นผู้อนุมัติ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideDownloadApproverSignature && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onDownloadApproverSignature) {
                  onDownloadApproverSignature(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/files/fil013.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ดาวน์โหลดลายเซ็นผู้อนุมัติ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideEditNoteOther && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onEditNoteOther) {
                  onEditNoteOther(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/general/gen051.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                แก้ไขหมายเหตุอื่นๆ
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {!hideEditNoteOther && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onAssignSales) {
                  onAssignSales(id)
                }
              }}>
              <KTSVG
                path='/media/icons/duotune/general/gen051.svg'
                className='svg-icon svg-icon-1x me-1'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                มอบหมายผู้ขาย
              </div>
            </a>
          </div>
        )}
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export default CustomActionCell
